
















































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/modules/common'
@Component({
  name: 'real-person',
  components: {}
})
export default class RealPerson extends Vue {
  async created() {
    // 获取当前语言
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
    CommonModule.setLanguage(data)
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  // 返回
  handelBack() {
    this.$router.back()
  }
}
